// 紙張尺寸常數（與後端 OrderTemplate::PAPER_SIZE_TYPES 同步）

export const PAPER_SIZE_TYPES = {
  a4: { width: 210, height: 297, labelKey: 'enums.paper_size.a4' },
  a5: { width: 148, height: 210, labelKey: 'enums.paper_size.a5' },
  custom: { width: null, height: null, labelKey: 'enums.paper_size.custom' }
};

// 獲取紙張尺寸選項（用於 Select）
export const getPaperSizeOptions = (t) => {
  return Object.keys(PAPER_SIZE_TYPES).map(key => ({
    label: t(PAPER_SIZE_TYPES[key].labelKey),
    value: key
  }));
};

// 獲取實際的紙張尺寸
export const getActualPaperSize = (paperSizeType, customWidth, customHeight) => {
  if (paperSizeType === 'custom') {
    return {
      width: customWidth || 210,
      height: customHeight || 297
    };
  }

  const sizeConfig = PAPER_SIZE_TYPES[paperSizeType];
  return {
    width: sizeConfig?.width || 210,
    height: sizeConfig?.height || 297
  };
};
